import React from "react";
import { Link } from "react-router-dom";

const Grow = () => {
  return (
    <div className="dashboard-component" style={{ textAlign: "center" }}>
      <div className="row">
        <div className="col s12 m6 offset-m3">
          <div className="card grey darken-5">
            <div className="card-action">
              <span className="card-title">Grow</span>
            </div>
            <div className="card-content white-text">
              <div className="row">
                <div className="col s12 txt-center">
                  <img src={require("../../assets/app-grow.png")} alt="Grow" />
                  <h4>Coming Soon</h4>
                </div>
              </div>
            </div>
            <div className="card-action">
              <Link to="/" className="waves-effect waves-light btn">
                Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Grow;
